import { GroupOfUserInterface } from "../Interfaces/Entities";

export function transformGroupOfUserToNormalGroups(groupsOfUser: GroupOfUserInterface[]) {
	return groupsOfUser.map(groupOfUser => ({
		PK: groupOfUser.group_id,
		SK: groupOfUser.group_id,
		name: groupOfUser.label,
		students: []
	}))
}